import { render } from "./App.vue?vue&type=template&id=00b0d538&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\watersoftdesarrollo\\GitHub\\Sisflex_toma_pedidos_web\\Sistema\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__